import React from "react";
import { Flex, Box } from "rebass";
import FlatButton from "material-ui/FlatButton";
import ActionAdd from "material-ui/svg-icons/content/add";
import ViewList from "material-ui/svg-icons/action/view-list";

import { IconTitle } from "../components";

export const DivFormContainer = Box.extend`
  padding-top: 3em;
  @media only screen and (min-width: 768px) {
    padding-bottom: 1em;
    padding-top: 0em;
  }
`;

export const HeaderTitle = props => {
  return (
    <Flex
      w={[1]}
      direction={["column", "row"]}
      justify={["center", "space-between"]}
    >
      <IconTitle icon="agency" title={"resources.campaigns.titleUsers"} />
      <Flex
        px={[1]}
        pt={[1, 0]}
        align={["flex-end", "flex-start"]}
        justify={["flex-end"]}
        direction={["row"]}
        wrap
      >
        <FlatButton
          icon={<ViewList />}
          href={`#/campaigns`}
          label="List"
          primary={true}
        />
        <FlatButton
          icon={<ActionAdd />}
          href={`#${props.match.url}/create`}
          label="Add"
          primary={true}
        />
      </Flex>
    </Flex>
  );
};
export const HeaderTitleChart = props => {
  return (
    <Flex
      w={[1]}
      direction={["column", "row"]}
      justify={["center", "space-between"]}
    >
      <IconTitle icon="agency" title={"resources.campaigns.titleChart"} />
      <Flex
        px={[1]}
        pt={[1, 0]}
        align={["flex-end", "flex-start"]}
        justify={["flex-end"]}
        direction={["row"]}
        wrap
      >
        <FlatButton
          icon={<ViewList />}
          href={`#/campaigns`}
          label="List"
          primary={true}
        />
      </Flex>
    </Flex>
  );
};

export const HeaderTitleCollections = props => {
  return (
    <Flex
      w={[1]}
      direction={["column", "row"]}
      justify={["center", "space-between"]}
    >
      <IconTitle icon="agency" title={"resources.campaigns.titleCollections"} />
      <Flex
        px={[1]}
        pt={[1, 0]}
        align={["flex-end", "flex-start"]}
        justify={["flex-end"]}
        direction={["row"]}
        wrap
      >
        <FlatButton
          icon={<ViewList />}
          href={`#/campaigns`}
          label="List"
          primary={true}
        />
      </Flex>
    </Flex>
  );
};



// WEBPACK FOOTER //
// ./src/campaigns/styled.js